import { FC } from "react";

import {
	FieldLayout,
	LabelPosition,
	RHookFormNumberFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FieldWrapper } from "../../FieldWrapper/FieldWrapper";
import { RHookFormNumericFormatTextField } from "../../TaxSlipDataInput/RHookFormNumericFormatTextField";

interface IQHSFPrimaryAndManufacturingSetupFieldsPanel {}
export const QHSFPrimaryAndManufacturingSetupFieldsPanel: FC<IQHSFPrimaryAndManufacturingSetupFieldsPanel> = ({}) => {
	return (
		<div>
			<RHookFormNumberFieldWithLabel
				label="Min."
				id="minimumQhsfPrimaryManufacture"
				testId={`minimum-Qhsf-Primary-Manu-facture`}
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				label="Max."
				id="maximumQhsfPrimaryManufacture"
				testId={`maximum-Qhsf-Primary-Manufacture`}
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				id={"normalizeQhsfPrimaryManufacture"}
				label="Normalize"
				testId="normalize-Qhsf-Primary-Manufacture"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				id={"rate1QhsfPrimaryManufacture"}
				label="Rate 1"
				testId="rate1-Qhsf-Primary-Manufacture"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				label="Rate 2"
				id="rate2QhsfPrimaryManufacture"
				testId={`rate2-Qhsf-Primary-Manufacture`}
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
		</div>
	);
};
